import { ContainerComponent, wrap } from 'AppReact';
import Schema from 'AppReact/schema';
import { InputError, Input } from 'molecules';
import { Seprator, SubSectionLabel } from '../../../../common/atoms';
import { SubsectionHeader } from '../../../../common/molecules';
import { FieldWrapper } from '../../../../common/wrappers';
import { emergencyContactsSchema, defaultEmergencyContacts } from '../../../../types';
import { isLastItem } from '../../../../utils';
import Controller from './controller';


const WrappedInput = wrap(Input, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);

const EmergencyContact = {
    controller: Controller,
    name: "EmergencyContact",
    initialProps: ({ language, emergencyContact, emergencyContacts, onReview }) => ({ language, emergencyContact, emergencyContacts, onReview }),
    props: {
        emergencyContact: Schema(emergencyContactsSchema, 'object', { defaultValue: defaultEmergencyContacts }),
        emergencyContacts: Schema(emergencyContactsSchema, 'array'),
        onReview: Schema('boolean', 'primitive'),
        language: Schema( {}, 'object'),
    },
    elements: [
        {
            component: SubSectionLabel,
            name: 'SubSectionLabel',
            renderIf: ({ emergencyContact,  emergencyContacts }) => emergencyContacts && emergencyContacts?.length> 0 && emergencyContact.id == emergencyContacts[0].id,
            displayValue: ({ emergencyContact }) => emergencyContact?.name || "Contact name",
        },
        {
            component: SubsectionHeader,
            name: 'DeleteButton',
            renderIf: ({ emergencyContact, emergencyContacts }) => emergencyContacts && emergencyContacts?.length> 0 && emergencyContact.id !== emergencyContacts[0].id,
            bindings: ({ emergencyContact, emergencyContacts }) => ({ label: emergencyContact?.name || "Contact name", resourceList: emergencyContacts, id: emergencyContact.id })
        },
        {
            component: WrappedInput,
            name: 'Name',
            bindings: ({ language, emergencyContacts, emergencyContact }) => ({ emergencyContacts, emergencyContact, label: `${language?.name || 'Name'}:` , value: emergencyContact.name })
        },
        {
            component: WrappedInputError,
            name: 'NameError',
            bindings: ({ emergencyContact }) => ({error: emergencyContact.nameError}),
            renderIf: ({ emergencyContact, onReview }) => !!emergencyContact.nameError && !onReview,
        },
        {
            component: WrappedInput,
            name: 'PhoneNumber',
            bindings: ({ language, emergencyContacts, emergencyContact }) => ({ emergencyContacts, emergencyContact, label: `${language?.phoneNumber || 'Phone Number'}:` , value: emergencyContact.phoneNumber })
        },
        {
            component: WrappedInputError,
            name: 'PhoneNumberError',
            bindings: ({ emergencyContact }) => ({error: emergencyContact.phoneNumberError }),
            renderIf: ({ emergencyContact, onReview }) => !!emergencyContact.phoneNumberError && !onReview,
        },
        {
            component: WrappedInput,
            name: 'Email',
            bindings: ({ emergencyContacts, emergencyContact }) => ({ emergencyContacts, emergencyContact, label: 'Email:', value: emergencyContact.email })
        },
        {
            component: WrappedInputError,
            name: 'EmailError',
            bindings: ({ emergencyContact }) => ({error: emergencyContact.emailError}),
            renderIf: ({ emergencyContact, onReview }) => !!emergencyContact.emailError && !onReview
        },
        {
            component: WrappedInput,
            name: 'Relationship',
            bindings: ({ language, emergencyContacts, emergencyContact }) => ({ emergencyContacts, emergencyContact, label: `${language?.relationship || 'Relationship'}:` , value: emergencyContact.relationship })
        },
        {
            component: WrappedInputError,
            name: 'RelationshipError',
            bindings: ({ emergencyContact }) => ({error: emergencyContact.relationshipError}),
            renderIf: ({ emergencyContact, onReview }) => !!emergencyContact.relationshipError && !onReview
        },
        {
            component: Seprator,
            name: 'Seprator',
            displayValue: () => '',
            renderIf: ({ emergencyContact, emergencyContacts }) => isLastItem({ resource:emergencyContact, resourceList:emergencyContacts })
        },
    ],
}

export default ContainerComponent(EmergencyContact);
